import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';
import get from 'lodash/get';
import { getActiveUser } from '../../shared/redux/selectors';

import {
  loadAgency,
  createAgency,
  createBrand,
  createEngagement,
  createCampaign,
  loadCampaign,
  loadActiveUser,
  loadBrands
} from '../../shared/redux/entities/actions';

function mapStateToProps(state,props){
  const activeUser = getActiveUser(state);

  return {
    activeUser:activeUser,
    activeAgency:get(state,['entities','agencies',activeUser.agencyId],{})
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadAgency,
    createAgency,
    createBrand,
    createEngagement,
    createCampaign,
    loadCampaign,
    loadActiveUser,
    loadBrands
  },dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/OnboardingTutorialSetup/connect.js